import * as React from 'react';
import { TextAction } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { Link } from 'react-router-dom';
import { ResponsiveHeaderNav } from '@leagueplatform/solutions-foundation';
import { EVENT_NAME, trackAnalyticsEvent } from '@leagueplatform/analytics';
import logoWithText from 'assets/my-care-pilot-logo.svg';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import { useUserMenuConfig } from 'components/header-nav/use-user-menu-config.hook';
import { useTransparentHeader } from 'hooks/use-transparent-header.hook';
import { useNavLinksList } from './use-nav-links-list.hook';

const Logo = () => {
  const { formatMessage } = useIntl();
  return (
    <TextAction
      as={Link}
      to={APP_MANAGED_ROUTES.HOME}
      onClick={() =>
        // TODO: Verify correct analytics parameters
        trackAnalyticsEvent(EVENT_NAME.NAVIGATION_TAB_CLICKED, {
          screen_name: 'Navigation Bar',
          product_area: 'Navigation Bar',
          detail: 'Nav Bar Logo clicked',
          sub_detail: APP_MANAGED_ROUTES.HOME,
        })
      }
    >
      <img
        src={logoWithText}
        height="18px"
        alt={formatMessage({ id: 'STR_APP_NAME' })}
      />
    </TextAction>
  );
};

export const AppNavBarComponent = React.memo(() => {
  const { navLinks } = useNavLinksList();
  const { userMenu } = useUserMenuConfig();
  const isTransparent = useTransparentHeader();

  return (
    <ResponsiveHeaderNav
      navLinks={navLinks}
      mobileNavLinkStyling={{
        color: '$onSurfaceTextPrimary',
        fontWeight: 'bold',
        padding: '$one $none',
      }}
      navLinkStyling={{
        padding: 0,
        margin: '$none $one',
        '&:first-child': {
          marginInlineStart: '$two',
        },
      }}
      logo={<Logo />}
      userMenu={userMenu}
      headerStyling={{
        ...(isTransparent && {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        }),
        transition: 'background-color 300ms ease, box-shadow 300ms ease',
      }}
    />
  );
});
